"use strict";

exports.__esModule = !0;
exports.default = void 0;
var themeHelper = {
  white: function white(props) {
    return props.theme.colors.white;
  },
  blue: function blue(props) {
    return props.theme.colors.blue;
  },
  black: function black(props) {
    return props.theme.colors.black;
  },
  red: function red(props) {
    return props.theme.colors.red;
  },
  blackBlue: function blackBlue(props) {
    return props.theme.colors.blackBlue;
  },
  darkBlue: function darkBlue(props) {
    return props.theme.colors.darkBlue;
  },
  lightGrey1: function lightGrey1(props) {
    return props.theme.colors.lightGrey1;
  },
  lightGrey2: function lightGrey2(props) {
    return props.theme.colors.lightGrey2;
  },
  lightGrey3: function lightGrey3(props) {
    return props.theme.colors.lightGrey3;
  },
  greyBackground: function greyBackground(props) {
    return props.theme.colors.greyBackground;
  },
  // spaces
  .5: function _(props) {
    return props.theme.space[.5] + "px";
  },
  1: function _(props) {
    return props.theme.space[1] + "px";
  },
  1.5: function _(props) {
    return props.theme.space[1.5] + "px";
  },
  2: function _(props) {
    return props.theme.space[2] + "px";
  },
  2.5: function _(props) {
    return props.theme.space[2.5] + "px";
  },
  3: function _(props) {
    return props.theme.space[3] + "px";
  },
  3.5: function _(props) {
    return props.theme.space[3.5] + "px";
  },
  4: function _(props) {
    return props.theme.space[4] + "px";
  },
  4.5: function _(props) {
    return props.theme.space[4.5] + "px";
  },
  5: function _(props) {
    return props.theme.space[5] + "px";
  },
  // Media
  // eslint-disable-next-line security/detect-object-injection
  media: function media(field) {
    return function (props) {
      return props.theme.media[field];
    };
  }
};
var _default = themeHelper;
exports.default = _default;